import React,{useEffect, useState} from "react"
import {Modal,Label,Input,Row,Col} from "reactstrap"
import "../../assets/scss/manual/manual.scss";
import toast from 'react-hot-toast';
import axios from "axios";
import AppConfig from "constants/config";

const DeleteAccount = (prop) => {
    const {deleteOpen, toggleDelete, setDeleteOpen, user, getAccountsData, setSelectedUser} = prop;
    const [loading, setLoading] = useState(false);

    const handleRemoveAccess = async() => {
        setLoading(true);
        try {
            const {data} = await axios.post(`${AppConfig.baseUrl}/customer/change_status`, {id: user.customer_id._id, status:'inactive'},{
              headers: { token: localStorage.getItem("token") }
            });
            if(!data.error){
                toast.success('Account access removed successfully');
                getAccountsData({})
                handleClosePopup()
            }
            else{
                throw new Error(data.title);
            }
        } catch (error) {
            toast.error(error.message || 'Something went wrong');
        }
        setLoading(false);
    }

    const handleClosePopup = () => {
        setDeleteOpen(false);
        setSelectedUser({})
    }

    return (
        <Modal
            isOpen={deleteOpen}
            toggle={() => {
                toggleDelete();
            }}
            centered
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0">Remove Access</h5>
                <button
                    type="button"
                    onClick={() => {
                        handleClosePopup()
                    }}
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <form>
                    <div className="mb-3">
                        Are you sure you want to remove access for this account ?
                    </div>
                    <div className="modal-footer mt-0">
                        <button
                            type="button"
                            className="btn bg-theme-color"
                            onClick={() =>
                                handleClosePopup()
                            }
                            disabled={loading}
                        >
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            No
                        </button>
                        <button type="button" className="btn bg-theme-color" onClick={handleRemoveAccess} disabled={loading}>
                            {
                                loading && <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> 
                            }
                            Yes
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}

export default DeleteAccount